import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 32px;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 0 48px;
  }

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    max-width: 1100px;
  }
`

export default Container
